import { ToPayMixin } from '@skylab-shared/business';
import { BO, BusinessObjectBase, QueryBus, Weaver } from '@skylab-shared/core';
import { ExchangeRateModel, PurchaseEInvoiceDocumentItemModel, PurchaseEInvoiceDocumentModel } from '@skylab-shared/dataModel';
import { PurchaseDocumentPaymentsBOPart } from './parts/purchase-document-payments.bo-part';
import { PurchaseDocumentValidationBOPart } from './parts/purchase-document-validation.bo-part';
import { PurchaseDocumentVatDeductionDateBOPart } from './parts/purchase-document-vat-deduction-date.bo-part';

export interface PurchaseEInvoiceDocumentBO extends ToPayMixin<PurchaseEInvoiceDocumentModel> {};

@BO({
    modelType: PurchaseEInvoiceDocumentModel,
    mixins: [ToPayMixin]
})
export class PurchaseEInvoiceDocumentBO extends BusinessObjectBase<PurchaseEInvoiceDocumentModel> {
    public constructor(
        weaver: Weaver,
        queryBus: QueryBus
    ) {
        super(weaver);
        this.parts.push(new PurchaseDocumentValidationBOPart(weaver, queryBus));
        this.parts.push(new PurchaseDocumentPaymentsBOPart(weaver));
        this.parts.push(new PurchaseDocumentVatDeductionDateBOPart(weaver));
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        this.registerDocumentReadonlyRules();
    }

    private registerDocumentReadonlyRules(): void {
        const modelType = PurchaseEInvoiceDocumentModel;
        this.readonly.addRule([
            [modelType, 'currencyId'],
            [modelType, 'documentNumber'],
            [modelType, 'issueDate'],
            [modelType, 'seller'],
            [modelType, 'issuer'],
            [modelType, 'numberingId'],
            [modelType, 'recipient'],
            [modelType, 'communityTransactionId'],
            [modelType, 'jpkVatGroups'],
            [modelType, 'transactionLocation'],
            [modelType, 'externalDocumentNumber'],
            [modelType, 'externalDocumentNumber'],
            [modelType, 'paymentMethodId'],
            [modelType, 'dueDate'],
            [modelType, 'dueDateDays'],
            [modelType, 'ksefDocumentId'],
            [modelType, 'ksefCollectiveIdentifier'],
            [modelType, 'ksefDocumentKind'],
            [modelType, 'cashBasis'],
            [modelType, 'splitPayment'],
            [modelType, 'note'],
            [modelType, 'customDueDateDescription'],
            [modelType, 'exchangeRate'],
            [modelType, 'deliveryDate'],
        ], () => true);

        this.readonly.setReadonlyOnSubtree(PurchaseEInvoiceDocumentItemModel, () => true);
        this.readonly.setReadonlyOnSubtree(ExchangeRateModel, () => true);
    }
}
